import 'Capabilities/angularModule';

export default angular.module('ClientStorage', ['Capabilities']);
